import React from 'react';
import SiteFooter from '../components/SiteFooter';

export default function Rules() {
  return (
    <div style={{background:'#F6F4EF', minHeight:'100vh'}}>
      <div style={{maxWidth:900, margin:'0 auto', padding:'24px 16px'}}>
        <h1>Правила обміну</h1>
        <ul style={{lineHeight:1.7}}>
          <li>Приймаємо паперові книги у доброму стані (без відсутніх сторінок, сильних пошкоджень чи намокання).</li>
          <li>Монети нараховуються за формулою сервісу залежно від сторінок і року видання.</li>
          <li>Взяти книгу коштує на <b>15%</b> більше за суму, що нараховується на баланс.</li>
          <li>Книгообіг не приймає книги російською мовою</li>
          <li>Книгообіг приймає книги тільки в яких рік видання 2000 і молодше</li>
          <li>Сервіс лишає за собою право відмовити у прийомі окремих видань.</li>
        </ul>
        <p style={{color:'#374151'}}>Підпитання? Напишіть нам: <a href="mailto:knyhoobih@gmail.com">knyhoobih@gmail.com</a>.</p>
      </div>
      <SiteFooter />
    </div>
  );
}

